export enum PageLink {
  First = "first",
  Last = "last",
  Next = "next",
  Previous = "previous",
}

export interface PageLinkPayload {
  limit: number;
  total: number;
  offset: number;
  link: PageLink;
}

export const getNextOffsetByLinkType = ({
  total,
  offset,
  limit,
  link,
}: PageLinkPayload): number => {
  switch (link) {
    case PageLink.First:
      return 0;
    case PageLink.Last:
      return Math.floor((total - 1) / limit) * limit;
    case PageLink.Previous:
      return offset - limit;
    case PageLink.Next:
      return offset + limit;
    default:
      throw new RangeError("Invalid page link");
  }
};
